import { putResolveNotifications } from "src/requests/notifications/requests";
import { EwaThunk } from "src/store/types";
import { refetchNotificationsRN } from "src/utils/nativeUtils";
import { resolveNotifications } from "../actionCreators";
import { getNotificationIdsToResolveForIds } from "../selectors";

export const resolveNotificationsThunk =
  (ids: number[]): EwaThunk =>
  async (dispatch, getState) => {
    const notificationIds = getNotificationIdsToResolveForIds(getState(), ids);

    try {
      await putResolveNotifications(notificationIds);
      dispatch(resolveNotifications({ notificationIds }));
      refetchNotificationsRN();
    } catch (e) {
      console.error("Error during resolving of notifications =>", e);
    }
  };
